import React, { useState, useEffect, useRef } from "react";
import { Turnstile } from "@marsidev/react-turnstile";
import { getTurnstileSiteKey } from "../../Helpers/ConfigProvider";
import commonStyles from "../../Components/Shared/commonStyles.module.css";
import styles from "./GetChristmasSorted.module.css";
import ErrorLabel, {
  ErrorBody,
} from "../../Components/Shared/Errors/ErrorLabel";
import Spinner from "../../Components/Shared/Spinner/Spinner";
import Modal from "../../Components/Shared/Modal/Modal";
import useContactStore from "../../Stores/useContactStore";

function GetChristmasSortedForm({ dates }) {
  const [bookingDetails, setBookingDetails] = useState({
    Name: "",
    Email: "",
    Phone: "",
    Session: "",
    Tickets: 1,
    EmailMarketing: false,
  });

  const { sendGetChristmasSortedForm, sendingChristmas, errors } = useContactStore();
  

  // const [errors, setErrors] = useState([]);
  // const [sendingMessage, setSendingMessage] = useState(false);

  const [formSubmitted, setFormSubmitted] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [hideSubmitButton, setHideSubmitButton] = useState(false);

  const turnstileSiteKey = getTurnstileSiteKey();
  const [token, setToken] = useState(null);
  const [pendingSubmit, setPendingSubmit] = useState(false);
  const turnstileRef = useRef(null);

  const handleTurnstileSuccess = (t) => {
    setToken(t);
    submitForm(t);
  };

  // Mock function to simulate sending the contact form
  // const sendBookingForm = async (details) => {
  //   // Simulate an API call delay
  //   setSendingMessage(true);
  //   return new Promise((resolve) => {
  //     setTimeout(() => {
  //       console.log("Booking details sent:", details);
  //       resolve(true); // Simulate a successful response
  //       setSendingMessage(false);
  //     }, 1000);
  //   });
  // };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setBookingDetails((prevDetails) => ({
      ...prevDetails,
      [name]: value,
    }));
  };

  const submitForm = async (turnstileToken) => {
    setPendingSubmit(false);

    const response = await sendGetChristmasSortedForm({
      ...bookingDetails,
      turnstileToken,
    });
    if (response === false) {
      setFormSubmitted(false);
    } else {
      setFormSubmitted(true);
    }
    setHideSubmitButton(false);
    setShowModal(true);
    setToken(null);
    return response;
  };

  const handleSubmit = async (e) => {
    setHideSubmitButton(true);
    e.preventDefault();
    setPendingSubmit(true); // this mounts the Turnstile, which auto-runs
  };

  const hasErrors = (propertyName) => {
    if (errors && errors.length > 0) {
      return errors.some((error) => error.PropertyName === propertyName);
    }
    return false;
  };

  const getErrorMessages = (propertyName) => {
    if (errors && errors.length > 0) {
      const error = errors.find((error) => error.PropertyName === propertyName);
      return error ? error.ErrorMessages : [];
    }
    return [];
  };

  const closeModal = () => {
    setShowModal(false);
  };

  return (
    <div className={`${commonStyles.section} `}>
      {sendingChristmas && (<Spinner />)}
      {showModal && (
        <Modal
          isOpen={showModal}
          onClose={closeModal}
          title={formSubmitted ? "Message Sent" : "Error"}
        >
          {formSubmitted ? (
            <p>Thank you for your reservation. We will confirm shortly.</p>
          ) : (
            <p>There was an error sending your reservation. Please try again later.</p>
          )}
          <button className={commonStyles.btn} onClick={closeModal}>Close</button>
        </Modal>
      )}     
      <div className={commonStyles.container}>
        <span className={`${commonStyles.eyebrow} ${styles.GetInTouchLabel}`}>
          Reserve your seat today
        </span>
        <form
          className={`${commonStyles.card} ${styles.contactFormWrapper}`}
          onSubmit={handleSubmit}
        >
          <div className={styles.columns}>
            <div className={styles.formDetails}>
              <h3>Reservation Details</h3>
              <div className={styles.formGroup}>
                <ErrorLabel
                  LabelName="Name"
                  labelFor="Name"
                  hasErrors={hasErrors("Name")}
                  errorMessages={getErrorMessages("Name")}
                  className=""
                />
                <input
                  type="text"
                  id="Name"
                  name="Name"
                  value={bookingDetails.name}
                  onChange={handleInputChange}
                  autoComplete="name"
                />
              </div>
              <div
                className={`${styles.formGroup}  ${hasErrors("Email") ? styles.error : ""}`}
              >
                <ErrorLabel
                  LabelName="Email"
                  labelFor="Email"
                  hasErrors={hasErrors("Email")}
                  errorMessages={getErrorMessages("Email")}
                  className=""
                />
                <input
                  type="email"
                  id="Email"
                  name="Email"
                  value={bookingDetails.email}
                  onChange={handleInputChange}
                  autoComplete="email"
                />
              </div>
              <div className={`${styles.formGroup} `}>
                <ErrorLabel
                  LabelName="Phone"
                  labelFor="Phone"
                  hasErrors={hasErrors("Phone")}
                  errorMessages={getErrorMessages("Phone")}
                  className=""
                />
                <input
                  type="tel"
                  id="Phone"
                  name="Phone"
                  value={bookingDetails.phone}
                  onChange={handleInputChange}
                  autoComplete="tel"
                />
              </div>
              <div className={`${styles.formGroup} `}>
                <ErrorLabel
                  LabelName="Session"
                  labelFor="Session"
                  hasErrors={hasErrors("Session")}
                  errorMessages={getErrorMessages("Session")}
                  className=""
                />
                <select
                  id="Session"
                  name="Session"
                  value={bookingDetails.Session}
                  onChange={handleInputChange}
                >
                <option value="">Select a session</option>
                  {dates.map((date, index) => (
                    <option key={index} value={date.date + " " + date.time + " " + date.location}>
                      {date.date} - {date.time} - {date.location}
                    </option>
                  ))}
                </select>
              </div>
              <div className={`${styles.formGroup} `}>
                <ErrorLabel
                  LabelName="Reserve your seat today"
                  labelFor="Tickets"
                  hasErrors={hasErrors("Tickets")}
                  errorMessages={getErrorMessages("Tickets")}
                  className=""
                />
                <input
                  type="number"
                  id="Tickets"
                  name="Tickets"
                  value={bookingDetails.Tickets}
                  onChange={handleInputChange}
                  min="1"
                  max="12"
                />
              </div>
            </div>

            <div className={styles.formGroupCheckbox}>
              <input
                type="checkbox"
                id="EmailMarketing"
                name="EmailMarketing"
                checked={bookingDetails.EmailMarketing}
                onChange={(e) =>
                  setBookingDetails((prevDetails) => ({
                    ...prevDetails,
                    EmailMarketing: e.target.checked,
                  }))
                }
              />
              Yes, I’d like to receive occasional updates and offers from Match
              Hampers. Sign me up for email marketing.
            </div>
          </div>
          {pendingSubmit && (
            <Turnstile
              siteKey={turnstileSiteKey}
              onSuccess={handleTurnstileSuccess}
              onExpire={() => setToken(null)}
              onError={() => setPendingSubmit(false)}
              ref={turnstileRef}
              // options={{
              //   appearance: "execute",
              // }}
              // options={{
              //   size: "compact", // Set the size to "invisible" for invisible CAPTCHA
              //   language: "en",
              // }}
            />
          )}
          {!hideSubmitButton && (
            <button
              type="submit"
              className={`${styles.submitButton} ${commonStyles.btn} ${commonStyles.btnPrimary}`}
            >
              Submit
            </button>
          )}
        </form>
      </div>
    </div>
  );
}

export default GetChristmasSortedForm;
